import RichContent from "@/components/modules/RichContent/RichContent";
import { Background } from "@/components/utils/Background";
import { usePadding } from "@/components/utils/Padding";
import useUtils from "@/hooks/useUtils";
import { DESKTOP } from "@/utils/appConstants";
import { RichColumnsPropTypes } from "./propTypes";
import "./styles.scss";

/* #META
 {
  "NAME": "RichColumns",
  "CLASSNAME": "rich-columns-component",
  "URL": "http://nicasource.local"
 }
#ENDMETA */

const RichColumns = ({ data }) => {
  // Use nullish coalescing to ensure data and its nested objects are defined
  const {
    // Background component
    background_component: backgroundComponent = {},
    // Columns gap
    columns_gap: columnsGap,
    // Columns
    columns = [],
    // Padding component
    padding_component: paddingComponent = {},
  } = data ?? {};

  const { device } = useUtils();
  const desktop = device === DESKTOP;

  const paddingStyle = usePadding(paddingComponent);

  const columnsStyle = {
    ...(columnsGap && { gap: `${columnsGap}px` }),
  };

  if (!columns) {
    return null;
  }

  return (
    <section className="rich-columns-component component-module" style={paddingStyle}>
      {/* Background */}
      <Background asBackground {...backgroundComponent} />

      <div className="rich-columns" style={columnsStyle}>
        {columns.map((column, index) => {
          const {
            column_order: columnOrder,
            column_width: columnWidth,
            component: richContentComponent,
            display_column_order: displayColumnOrder,
            display_column_width: displayColumnWidth,
          } = column ?? {};

          const RichContentProps = {
            data: {
              component: richContentComponent,
            },
          };

          const columnStyle = {
            ...(displayColumnOrder && { order: columnOrder || 0 }),
            ...(displayColumnWidth &&
              desktop && { flex: "0 0 auto", width: `${columnWidth}%` || "auto" }),
          };

          return (
            <div className="rich-columns-column" key={`rich-column-${index}`} style={columnStyle}>
              <RichContent {...RichContentProps} />
            </div>
          );
        })}
      </div>
    </section>
  );
};

RichColumns.propTypes = {
  data: RichColumnsPropTypes,
};

export default RichColumns;
